/**
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React from 'react';
import ReactDOM from 'react-dom';
import '@scuf/common/honeywell-combined/theme.css';
import '@scuf/datatable/honeywell-combined/theme.css';
import './index.css';
import { Route } from 'react-router-dom';
import { AppProvider, AppHeader, KeystoneApp, PrivateRoute } from '@keystone/common';
import Routes from './common/routes';
import VadProvider from './pages/vad/VadContext';
import Vad from './pages/vad/VadScan';
import ViewRules from './pages/vad/ViewRules';
import CreateRule from './pages/vad/CreateRule';
import EditRule from './pages/vad/EditRule';
import historyDetails from './pages/vad/historyDetails';
import SLATable from './pages/sla/SLATable';
import CreateSLA from './pages/sla/CreateSLA';
import SLASubmit from './pages/sla/SLASubmit';
import SLASuccess from './pages/sla/SLASuccess';
import SLAInvalidLink from './pages/sla/SLAInvalidLink';
import ViewSLA from './pages/sla/ViewSLA';
import ViewConfiguration from './pages/common/ViewConfiguration';
import ConfigurationProvider from './pages/common/ConfigurationContext';
import Home from './pages/Home';
import TaskProvider from './pages/task/TaskContext';
import Task from './pages/task/TaskScan';
import TaskHistory from './pages/task/TaskHistory';
import Nav from './partials/Nav';

ReactDOM.render(
  <AppProvider>
    <TaskProvider>
      <VadProvider>
        <ConfigurationProvider>
          <KeystoneApp
            publicRoutes={[
              <Route path={Routes.SLASubmit} component={SLASubmit} />,
              <Route path={Routes.ViewSLA} component={ViewSLA} />,
              <Route path={Routes.SLASuccess} component={SLASuccess} />,
              <Route path={Routes.SLAInvalidLink} component={SLAInvalidLink} />,
            ]}
            privateRoutes={[
              <PrivateRoute exact path={Routes.Home} component={Home} />,
              <PrivateRoute exact path={Routes.Task} component={Task} />,
              <PrivateRoute exact path={Routes.TaskHistory} component={TaskHistory} />,
              <PrivateRoute exact path={Routes.Vad} component={Vad} />,
              <PrivateRoute exact path={Routes.Rules} component={ViewRules} />,
              <PrivateRoute exact path={Routes.CreateRule} component={CreateRule} />,
              <PrivateRoute exact path={Routes.EditRule} component={EditRule} />,
              <PrivateRoute exact path={Routes.History} component={historyDetails} />,
              <PrivateRoute exact path={Routes.CreateSLA} component={CreateSLA} />,
              <PrivateRoute exact path={Routes.SLATable} component={SLATable} />,
              <PrivateRoute exact path={Routes.ViewConfiguration} component={ViewConfiguration} />,
            ]}
            header={<AppHeader title="Honeywell Voice Partner Tools" />}
            nav={Nav}
          />
        </ConfigurationProvider>
      </VadProvider>
    </TaskProvider>
  </AppProvider>,
  document.getElementById('root')
);
